import { Line, Text } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useRef } from "react";
import { BEAM_LEFT_OFFSET, BEAM_TOP_OFFSET, SERIF } from "../../constants";
import { useSettings } from "../../hooks/useSettings";
import { useShelvingStore, useStoreRoom } from "../../store";

export const TotalDimensionHorizontal = () => {
    const groupRef = useRef<any>(null);
    const ref = useRef<any>(null);
    const textRef = useRef<any>(null);

    useFrame(() => {
        const currentShelving = useShelvingStore.getState().getCurrentShelving();
        const roomLength = useStoreRoom.getState().length;
        const roomHeight = useStoreRoom.getState().height;
        const roomDepth = useStoreRoom.getState().depth;
        const width = ["left", "right"].includes(currentShelving.name) ? roomDepth : roomLength;

        const total = currentShelving.length;
        const offset = currentShelving.offsetCeiling;
        const indent = currentShelving.sideIndent;

        if (groupRef.current) {
            groupRef.current.scale.x = total / 1000;
            groupRef.current.position.x = -(width / 2 - indent + BEAM_LEFT_OFFSET) / 1000;
            groupRef.current.position.y = (roomHeight - offset + BEAM_TOP_OFFSET) / 1000;
            groupRef.current.position.z = 0.1;
            textRef.current.position.x = -((width - total) / 2 - indent) / 1000;
            textRef.current.position.y =
                offset >= 250
                    ? (roomHeight - offset + BEAM_TOP_OFFSET * 2.5) / 1000
                    : (roomHeight - offset - BEAM_TOP_OFFSET) / 1000;
            textRef.current.text = total;
            textRef.current.position.z = 0.1;
        }
    });

    const { isVisibleSizes } = useSettings();
    if (!isVisibleSizes) {
        return null;
    }

    return (
        <group>
            <group renderOrder={10} ref={groupRef}>
                <Line
                    ref={ref}
                    points={[
                        [0, 0, 0],
                        [1, 0, 0],
                    ]}
                    lineWidth={2}
                    color="white"
                />
                <Line
                    points={[
                        [0, -SERIF, 0],
                        [0, SERIF, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
                <Line
                    points={[
                        [1, -SERIF, 0],
                        [1, SERIF, 0],
                    ]}
                    lineWidth={0.5}
                    color="white"
                />
            </group>
            <Text ref={textRef} color="white" anchorX="center" anchorY="middle">
                {" "}
            </Text>
        </group>
    );
};
